export default "__VITE_ASSET__mYvY7D08__"